/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GoalType = "completable" | "continuous" | "%future added value";
export type GoalDetailsReviewStatus_goal = {
    readonly nextReviewAt: string;
    readonly type: GoalType;
    readonly archived: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"GoalDetailsReviewCalculationOptions_goal">;
    readonly " $refType": "GoalDetailsReviewStatus_goal";
};
export type GoalDetailsReviewStatus_goal$data = GoalDetailsReviewStatus_goal;
export type GoalDetailsReviewStatus_goal$key = {
    readonly " $data"?: GoalDetailsReviewStatus_goal$data;
    readonly " $fragmentRefs": FragmentRefs<"GoalDetailsReviewStatus_goal">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GoalDetailsReviewStatus_goal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nextReviewAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archived",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GoalDetailsReviewCalculationOptions_goal"
    }
  ],
  "type": "Goal",
  "abstractKey": null
};
(node as any).hash = '51f0cbd1e57c89ff2167e7fc823a2e9d';
export default node;
